module.exports = __webpack_public_path__ + "static/media/recive.02239177.png";